import { ListFilterParams } from '../../_store/actions/base-list-filters.actions';

/** Query params that describe pagination/sorting rather than a filter selection. */
export const NON_FILTER_QUERY_PARAMS: string[] = ['page', 'order'];

export function stripNonFilterParams(params: ListFilterParams | null | undefined): ListFilterParams {
  const result: ListFilterParams = {};
  if (!params) {
    return result;
  }
  Object.keys(params).forEach((key) => {
    if (!NON_FILTER_QUERY_PARAMS.includes(key)) {
      result[key] = params[key];
    }
  });
  return result;
}

export function isEmptyParams(params: ListFilterParams | null | undefined): boolean {
  return !params || Object.keys(params).length === 0;
}
